import { render, staticRenderFns } from "./keyInformation.vue?vue&type=template&id=2a0035a9&scoped=true&"
import script from "./keyInformation.vue?vue&type=script&lang=js&"
export * from "./keyInformation.vue?vue&type=script&lang=js&"
import style0 from "./keyInformation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./keyInformation.vue?vue&type=style&index=1&id=2a0035a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0035a9",
  null
  
)

export default component.exports